// extracted by mini-css-extract-plugin
export default {"calendar-list-view__container":"CalendarListView_calendar-list-view__container__PX73I"};